import { getDefaultMiddleware } from '@reduxjs/toolkit'
import {
  reducer as userReducer,
  setUserToken,
  initialState as userInitialState,
} from './userSlice'
import {
  reducer as pricingReducer,
  initialState as pricingInitialState,
} from './pricingSlice'
import {
  reducer as localeReducer,
  setCurrency as setLocaleCurrency,
} from './localeSlice'
import { setToken } from 'js/api'
import { setCurrency } from 'js/pricing'
import deepmerge from 'deepmerge'

const saveAuthToken =
  ({ getState }) =>
  (next) =>
  (action) => {
    const { user } = getState()
    let authData: { accessToken: string; expiresAt: number }

    if (action.type === setUserToken.toString()) {
      authData = action.payload
    } else {
      authData = {
        accessToken: user.userToken,
        expiresAt: user.userTokenExpiration,
      }
    }

    setToken(authData)
    return next(action)
  }

const saveCurrency = (store) => (next) => (action) => {
  const { locale } = store.getState()
  if (action.type === setLocaleCurrency.toString()) {
    setCurrency(action.payload)
  } else if (locale.currency) {
    setCurrency(locale.currency)
  }

  return next(action)
}

function getStoreConfiguration(preloadedState = {}) {
  const persistedState = {
    pricing: pricingInitialState,
    user: userInitialState,
  }

  return {
    reducer: {
      user: userReducer,
      pricing: pricingReducer,
      locale: localeReducer,
    },
    initialState: deepmerge(preloadedState, persistedState),
    middleware: [...getDefaultMiddleware(), saveAuthToken, saveCurrency],
  }
}

export { getStoreConfiguration }
